import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { handleOptionSetValue } from "../../../../../../../../Utils/Helpers/optionSet.helper";
import { ListItemSecondaryAction } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    background: "var(--color-background-default)",
    height: "calc(100vh - 64px)",
    marginTop: "64px",
    position: "fixed",
    width: "100%",
    zIndex: "99999",
  },
  searchBar: {
    flexDirection: "row",
    background: "var(--color-background-paper)",
    color: "var(--color-text-primary)",
  },
  searchTabList: {
    width: "100%",
    "& .MuiTab-root": {
      color: "var(--color-text-secondary)",
    },
    "& button.Mui-selected": {
      color: "var(--color-primary-main)",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "var(--color-primary-main)",
    },
  },
  closeView: {
    padding: "10px",
    background: "var(--color-background-paper)",
    color: "var(--color-text-primary)",
    cursor: "pointer",
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
  },
  crmSubheader: {
    background: "var(--search-subheader-bg)",
    color: "var(--color-text-primary)",
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  crmListItem: {
    background: "var(--color-background-default)",
    cursor: "pointer",
    transition: "background 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      background: "var(--search-item-hover-bg)",
      boxShadow: "inset 3px 0 0 var(--color-primary-main)",
      "& $crmItemTitle": {
        color: "var(--color-primary-main)",
      },
      "& .MuiAvatar-root": {
        boxShadow: "0 0 0 2px var(--color-primary-main)",
      },
    },
  },
  crmItemTitle: {
    transition: "color 0.15s ease",
  },
  searchTabPanel: {
    padding: "0",
    marginTop: "8px",
    overflow: "auto",
    maxHeight: "calc(100vh - 124px)",
  },
  crmHeader: {
    "& > div": {
      minWidth: "30px",
    },
    "& > span": {
      fontSize: "12px",
      "& > b": {
        fontSize: "14px",
        marginRight: "8px",
      },
    },
  },
  actionItem: {
    maxWidth: "30%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "end",
    gap: "0.2rem",
  },
  chips: {
    backgroundColor: "var(--sidebar-background)",
    color: "var(--sidebar-fontcolor)",
    fontSize: "0.6rem",
    padding: "0.2rem",
    borderRadius: "0.2rem",
    fontWeight: 600,
  },
}));

const M_FullPageView = (props) => {
  const classes = useStyles();
  const { allCrmResult, setIsFullPage, handleClick, searchKey } = props;
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root} id="SearchFullView">
      <TabContext value={value}>
        <TabHeading
          allCrmResult={allCrmResult}
          handleChange={handleChange}
          setIsFullPage={setIsFullPage}
        />

        <TabBodyContent
          allCrmResult={allCrmResult}
          handleClick={handleClick}
          searchKey={searchKey}
        />
      </TabContext>
    </div>
  );
};
M_FullPageView.propTypes = {
  allCrmResult: PropTypes.array,
  setIsFullPage: PropTypes.bool,
  handleClick: PropTypes.func,
  searchKey: PropTypes.string,
};
export default M_FullPageView;

// TabHeading component
const TabHeading = (props) => {
  const classes = useStyles();
  const { handleChange, allCrmResult, setIsFullPage } = props;
  return (
    <>
      <AppBar position="static" color="transparent" className={classes.searchBar}>
        <TabList
          onChange={handleChange}
          aria-label="search"
          className={classes.searchTabList}
        >
          <Tab label="All" value="1" />

          {allCrmResult.map((list) => (
            <Tab
              key={list.crmRecordType}
              label={list.crmRecordType}
              value={list.crmRecordType}
            />
          ))}
        </TabList>
        <Paper
          elevation={0}
          className={classes.closeView}
          onClick={() => setIsFullPage(false)}
        >
          <HighlightOffIcon />
        </Paper>
      </AppBar>
    </>
  );
};
TabHeading.propTypes = {
  allCrmResult: PropTypes.array,
  handleChange: PropTypes.func,
  setIsFullPage: PropTypes.bool,
};

// TabBodyContent render body component
const TabBodyContent = (props) => {
  const classes = useStyles();
  const { allCrmResult, handleClick, searchKey } = props;
  return (
    <>
      <TabPanel value="1" className={classes.searchTabPanel}>
        <List subheader={<li />}>
          {allCrmResult.length > 0 ? (
            <>
              {allCrmResult.map((item) => (
                <li key={item.crmRecordType}>
                  <ul className={classes.ul}>
                    <ListSubheader
                      disableSticky
                      className={classes.crmSubheader}
                    >
                      {item.crmRecordType}
                    </ListSubheader>
                    {item.crmRecordDetails.map((list) => {
                      const { id, email, title, link, chips } = list;
                      return (
                        <ListItem
                          key={id}
                          onClick={() => handleClick(list)}
                          className={classes.crmListItem}
                        >
                          <ListItemAvatar>
                            <Avatar alt={title} src={link} />
                          </ListItemAvatar>
                          <ListItemText
                            primary={title}
                            secondary={handleOptionSetValue(email)}
                            primaryTypographyProps={{ className: classes.crmItemTitle }}
                            style={{
                              maxWidth: chips.length > 0 ? "70%" : "100%",
                            }}
                            secondaryTypographyProps={{
                              style: { whiteSpace: "break-spaces", color: "var(--color-text-secondary)" },
                            }}
                          />
                          {chips.length > 0 ? (
                            <ListItemSecondaryAction
                              className={classes.actionItem}
                            >
                              {chips.map((item) => {
                                if (item && item.trim() !== "") {
                                  return (
                                    <span className={classes.chips} key={item}>
                                      {item.toString()}
                                    </span>
                                  );
                                } else {
                                  <></>;
                                }
                              })}
                            </ListItemSecondaryAction>
                          ) : (
                            ""
                          )}
                        </ListItem>
                      );
                    })}
                  </ul>
                </li>
              ))}
            </>
          ) : (
            <ListItem className={classes.crmHeader}>
              <span>
                <b>{searchKey}</b>&nbsp;No results found
              </span>
            </ListItem>
          )}
        </List>
      </TabPanel>
      {allCrmResult.map((list) => (
        <TabPanel
          key={list.crmRecordType}
          value={list.crmRecordType}
          className={classes.searchTabPanel}
        >
          {list.crmRecordDetails.map((list, index, dataSet) => {
            return [
              <ListItem
                key={list.id}
                onClick={() => handleClick(list)}
                className={classes.crmListItem}
              >
                <ListItemAvatar>
                  <Avatar alt={list.title} src={list.link} />
                </ListItemAvatar>
                <ListItemText primary={list.title} />
              </ListItem>,
              index < dataSet.length - 1 ? <hr style={{ margin: 0 }} /> : "",
            ];
          })}
        </TabPanel>
      ))}
    </>
  );
};
TabBodyContent.propTypes = {
  allCrmResult: PropTypes.array,
  handleClick: PropTypes.func,
  searchKey: PropTypes.string,
};
